import { INaiveBayesClassifierParameters, INaiveBayesClassifierResult, ITarget } from '../naive-bayes-interfaces';

const countTargets = (params: INaiveBayesClassifierParameters) : ITarget[] => {
    const map: Map<string, number> = new Map(); // target value --> count

    for(const val of params.targetValues) {
        const count = map.get(val) ?? 0;
        map.set(val, count + 1);
    }

    const result: ITarget[] = [];

    for(const [targetValue, targetValueCount] of map) {
        result.push({
            value: targetValue,
            count: targetValueCount,
            probability: params.targetValues.length === 0 ? 0 : (targetValueCount / params.targetValues.length),
            dependencies: [],
            dependenciesProbability: 0,
            mone: 0,
        });
    }

    return result;
};


const calculateTargetDependencies = (params: INaiveBayesClassifierParameters, targets: ITarget[]) => {

    for(const target of targets) {

        let dependenciesProbability = 1;

        // check pairs (target_value, queries_item_value) like: (no, youth), (no, high), ...
        for(let c=0; c<params.question.length; c++) {
            const questionItem = params.question[c];

            let count = 0;
            for(let r=0; r<params.rows.length;r++){
                const row = params.rows[r];

                const cellValue = row[c];
                const targetValue = params.targetValues[r];

                if(cellValue === questionItem && targetValue === target.value) {
                    count++;
                }
            }

            const probability = target.count === 0 ? 0 : count / target.count;

            target.dependencies.push({
                field: params.titles[c],
                value: questionItem,
                probability,
                combinationCount: count,
                targetCount: target.count,
            });

            dependenciesProbability *= probability;
        }

        target.dependenciesProbability = dependenciesProbability;
        target.mone = target.probability * target.dependenciesProbability;
    }
};

export const calculateNaiveBayesClassifier = (params: INaiveBayesClassifierParameters) : INaiveBayesClassifierResult => {

    const targets = countTargets(params);

    calculateTargetDependencies(params, targets);

    let maxMone = 0;
    let maxProp = '';

    for(const target of targets) {
        if(target.mone > maxMone) {
            maxMone = target.mone;
            maxProp = `${ target.value }`
        }
    }

    return {
        targets,
        maxMone,
        maxProp,
    };
};